module.exports = __webpack_public_path__ + "img/pin__unpinned.e165bd91.svg";